export default __webpack_public_path__ + "static/media/castle.9f1ca587.ogg";